import React from 'react';

const Wallet: React.FC = () => {
  return (
    <svg viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.9996 3.55069L11.0859 3.38324L11.1111 10.7579L17.001 10.6371L17.0018 14.5936L0 14.9988V0L16.9989 0.250598L16.9996 3.55069Z" />
      <path d="M12.9061 5.39999L17.9072 5.55831L17.9231 8.79631L12.9061 8.9199V5.39999Z" />
    </svg>
  );
};

export { Wallet };
